import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { prettyStandingsUrl, prettyCalendarUrl } from '../../common/rcs_gaz_mc_core_FE';
import DynamicTable from '../../components/DynamicTable';
import Label from '../../components/shared/Label';
import StandingButton from '../../components/shared/StandingButton';
import * as types from '../../constants';
import { StandingWidgetWrapper, ButtonsWrapper, TitleWrapper, GradientWrapper } from './styles';

class StandingWidget extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    //perchè aggiornamento ogni 5 sec se non è un LIVE???
    //const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    const interval = 120000;
    this.sportTimer = setInterval(this.getStanding, interval);
    this.getStanding();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    if (this.sportTimer) {
      clearInterval(this.sportTimer);
    }
  }

  getStanding = () => {
    const {
      competitionId, sportId, actions, widgetId,
    } = this.props;
    actions.getStandings(sportId, competitionId, widgetId);
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  render() {
    const {
      actions, dictionary, standings, competitionId, sportId, widgetId,
    } = this.props;
    const { isMobile } = this.state;
    const standing = standings[widgetId];
    let tableRowsKey = 'competitionTeams';
    let tableId = 'generalRanking';
    let competitionName = dictionary.competitionTable.competitionName[competitionId];
    let gradientEnable = true;
    let gironeLabel = false;
    if (sportId === '2') {
      tableRowsKey = 'rugbyStandings';
      tableId = false;
      competitionName = dictionary.competitionTable.rugbyCompetitionName[competitionId];
    }
    if (sportId === '2') {
      if (competitionId === '4') {
        gradientEnable = false;
      }
    } else if (sportId === '1') {
      if (competitionId === '3' || competitionId === '5' || competitionId === '6' || competitionId === '616') {
        gradientEnable = false;
      }
    }
    if (sportId === '1') {
      if (competitionId === '3') {
        gironeLabel = true;
      }
    }
    return (
      <StandingWidgetWrapper>
        <GradientWrapper>
          {standing && standing.competitionDay &&
          <TitleWrapper>
            <Label
              label={`${competitionName} - ${process.env.REACT_APP_SITE === 'corriere' ? 'CLASSIFICA' : standing.competitionDay + dictionary.competitionTable.dayA}`}
              weight="bold"
              margin="0 0 16px"
              isCapitalize
              isTitleNarrowMedium
            />
          </TitleWrapper>
          }
          <DynamicTable
            actions={actions}
            data={standing}
            dictionary={dictionary.widgets.cols}
            tableRowsKey={tableRowsKey}
            tableId={tableId}
            isMobile={isMobile}
            competitionId={competitionId}
            sportId={sportId}
            isStandingWidget
            hasTitle
            enableGradient={gradientEnable}
            hasGironeLabel={gironeLabel}
          />
        </GradientWrapper>
        <ButtonsWrapper>
          <StandingButton
            color="buttonColor"
            background="transparent"
            label="Classifica"
            borderColor="gray"
            linkTo={prettyStandingsUrl(sportId, competitionId, process.env.REACT_APP_SITE)}
            width="30%"
            margin="15px 0px 25px 0px"
            size="16px"
            isTitleNarrowMedium
          />
          <StandingButton
            color="buttonColor"
            background="transparent"
            label="Calendario e risultati"
            borderColor="gray"
            linkTo={prettyCalendarUrl(sportId, competitionId, process.env.REACT_APP_SITE)}
            width="60%"
            margin="15px 0px 25px 0px"
            size="16px"
            isTitleNarrowMedium
          />
        </ButtonsWrapper>
      </StandingWidgetWrapper>
    );
  }
}

StandingWidget.propTypes = {
  actions: PropTypes.any,
  standings: PropTypes.any,
  competitionId: PropTypes.any,
  sportId: PropTypes.any,
  dictionary: PropTypes.any,
  widgetId: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    standings: state.standingReducer.standings,
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getStandings: (sportId, competitionId, widgetId) =>
        dispatch({
          type: types.GET_STANDINGS_REQUEST, sportId, competitionId, widgetId,
        }),
    },
  }),
)(StandingWidget);



// WEBPACK FOOTER //
// ./src/containers/StandingWidget/index.js